import React from 'react'
import PropTypes from 'prop-types'
import { unlinkFacebook } from '../../../api/facebook'
import { ToggleSwitch } from '@olxbr/ds-web'

const clickWrapper = (checked, connectToFacebook, onFacebookConnectedChange, onClick) => () => {
  if (onClick) onClick(checked)
  if (!checked) {
    connectToFacebook()
  } else {
    unlinkFacebook().then(result => onFacebookConnectedChange(!result))
  }
}

const Component = props => {
  const { checked, onFacebookConnectedChange, connectToFacebook, onClick } = props
  return (
    <ToggleSwitch
      aria-label="Conectar com o Facebook"
      checked={checked}
      onChange={clickWrapper(checked, connectToFacebook, onFacebookConnectedChange, onClick)}
    />
  )
}

Component.propTypes = {
  connectToFacebook: PropTypes.func.isRequired,
  onFacebookConnectedChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  checked: PropTypes.bool,
}

export default Component
